import '../../sass/pages/uslugi-1c.scss';

function initOneCTaskTabs(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-one-c-tabs]').forEach((tabs) => {
    if (tabs.dataset.oneCTabsReady === 'true') {
      return;
    }

    const buttons = Array.from(tabs.querySelectorAll<HTMLButtonElement>('[data-one-c-tab]'));
    const panels = Array.from(tabs.querySelectorAll<HTMLElement>('[role="tabpanel"]'));

    if (!buttons.length || !panels.length) {
      return;
    }

    tabs.dataset.oneCTabsReady = 'true';

    const activateTab = (button: HTMLButtonElement): void => {
      const panelId = button.dataset.oneCTab;

      buttons.forEach((item) => {
        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.id === panelId;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activateTab(button));

      button.addEventListener('keydown', (event) => {
        const lastIndex = buttons.length - 1;
        let nextIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = index === lastIndex ? 0 : index + 1;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = index === 0 ? lastIndex : index - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = lastIndex;
        } else {
          return;
        }

        event.preventDefault();
        buttons[nextIndex].focus();
        activateTab(buttons[nextIndex]);
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initOneCTaskTabs());
} else {
  initOneCTaskTabs();
}
